module.exports = __webpack_public_path__ + "assets/img/136aba9d78970b3bf70d09a37f32d404.png";